import { useEffect, useState } from "react";
import axios from "axios";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import { useParams, useSearchParams } from "react-router-dom";
import { toast, Bounce } from "react-toastify";

const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5002";

export default function SupplierRFQDetails() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const loggedInUserId = localStorage.getItem("userid") || "1";
  const id_user = searchParams.get("id_user") || loggedInUserId;

  const [loading, setLoading] = useState(true);
  const [rfq, setRfq] = useState<any>(null);
  const hasResponded = rfq?.response_price != null;

  const [form, setForm] = useState({
    price: "",
    production_time: "",
    time_unit: "days",
    message: "",
  });

  useEffect(() => {
    loadRFQ();
  }, []);

  const loadRFQ = async () => {
    try {
      const res = await axios.get(
        `${backendUrl}/api/supplier-rfq/${id}/${id_user}`,
      );
      setRfq(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const submitResponse = async () => {
    try {
      await axios.post(`${backendUrl}/api/supplier-rfq/respond`, {
        id_user,
        id_rfq: id,
        price: form.price,
        production_time: form.production_time,
        time_unit: form.time_unit,
        message: form.message,
      });

      toast.success("Response submitted successfully");
      loadRFQ();
    } catch (err: any) {
      console.error(err.response?.data || err.message);
      toast.error(err.response?.data?.error || "Error submitting response");
    }
  };
  if (loading) return <div className="p-5">Loading...</div>;
  if (!rfq) return <div className="p-5">RFQ not found</div>;

  return (
    <div
      className="container-fluid"
      style={{
        padding: "28px 36px",
        background: "#ffffff",
        minHeight: "100vh",
      }}
    >
      <Card
        className="border-0 rounded-4 p-4"
        style={{
          background: "#ffffff",
          boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#0f172a",
              marginBottom: 6,
            }}
          >
            {rfq.title}
          </h2>
          <div style={{ color: "#64748b", fontSize: 14 }}>RFQ Details</div>
        </div>

        <Row className="g-4" style={{ marginBottom: 24 }}>
          <Col md={6}>
            <Card
              className="border-1 rounded-4"
              style={{
                background: "#f8fafc",
                padding: "18px 16px",
                minHeight: 86,
              }}
            >
              <small className="text-muted">Segment</small>
              <div className="fw-semibold mt-1">{rfq.segment_name || "-"}</div>
            </Card>
          </Col>

          <Col md={6}>
            <Card
              className="border-1 rounded-4"
              style={{
                background: "#f8fafc",
                padding: "18px 16px",
                minHeight: 86,
              }}
            >
              <small className="text-muted">Deadline</small>
              <div className="fw-semibold mt-1">
                {rfq.deadline
                  ? new Date(rfq.deadline).toLocaleDateString()
                  : "-"}
              </div>
            </Card>
          </Col>

          <Col md={6}>
            <Card
              className="border-1 rounded-4"
              style={{
                background: "#f8fafc",
                padding: "18px 16px",
                minHeight: 86,
              }}
            >
              <small className="text-muted">Material</small>
              <div className="fw-semibold mt-1">{rfq.material || "-"}</div>
            </Card>
          </Col>

          <Col md={6}>
            <Card
              className="border-1 rounded-4"
              style={{
                background: "#f8fafc",
                padding: "18px 16px",
                minHeight: 86,
              }}
            >
              <small className="text-muted">Quantity</small>
              <div className="fw-semibold mt-1">{rfq.quantity || "-"}</div>
            </Card>
          </Col>
        </Row>

        <Card
          className="border-1 rounded-4"
          style={{
            background: "#f8fafc",
            padding: "18px 16px",
            marginBottom: 24,
          }}
        >
          <small className="text-muted">Description</small>
          <div className="mt-2" style={{ color: "#0f172a", lineHeight: 1.7 }}>
            {rfq.description || "-"}
          </div>
        </Card>

        {hasResponded ? (
          <Card
            className="border-1 rounded-4"
            style={{
              background: "#f0fdf4",
              padding: "20px 18px",
              border: "1px solid #dcfce7",
            }}
          >
            <div style={{ marginBottom: 16 }}>
              <h4
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#166534",
                  marginBottom: 0,
                }}
              >
                Your Response
              </h4>
            </div>

            <Row className="g-4">
              <Col md={6}>
                <Card
                  className="border-0 rounded-4"
                  style={{
                    background: "#ffffff",
                    padding: "18px 16px",
                    minHeight: 86,
                  }}
                >
                  <small className="text-muted">Price</small>
                  <div className="fw-semibold mt-1">
                    {rfq.response_price != null
                      ? new Intl.NumberFormat("fr-DZ", {
                          style: "currency",
                          currency: "DZD",
                        }).format(rfq.response_price)
                      : "-"}
                  </div>
                </Card>
              </Col>

              <Col md={6}>
                <Card
                  className="border-0 rounded-4"
                  style={{
                    background: "#ffffff",
                    padding: "18px 16px",
                    minHeight: 86,
                  }}
                >
                  <small className="text-muted">Production Time</small>
                  <div className="fw-semibold mt-1">
                    {rfq.response_time
                      ? `${rfq.response_time} ${rfq.response_time_unit || "days"}`
                      : "-"}
                  </div>
                </Card>
              </Col>

              <Col md={12}>
                <Card
                  className="border-0 rounded-4"
                  style={{ background: "#ffffff", padding: "18px 16px" }}
                >
                  <small className="text-muted">Message</small>
                  <div
                    className="mt-2"
                    style={{ color: "#0f172a", lineHeight: 1.7 }}
                  >
                    {rfq.response_message || "-"}
                  </div>
                </Card>
              </Col>

              <Col md={12}>
                <div>
                  <small className="text-muted">Status</small>
                  <div className="mt-2">
                    <span
                      style={{
                        padding: "6px 12px",
                        borderRadius: 999,
                        fontSize: 12,
                        fontWeight: 600,
                        background:
                          rfq.response_status === "ACCEPTED"
                            ? "#dcfce7"
                            : rfq.response_status === "REJECTED"
                              ? "#fee2e2"
                              : "#fef3c7",
                        color:
                          rfq.response_status === "ACCEPTED"
                            ? "#15803d"
                            : rfq.response_status === "REJECTED"
                              ? "#b91c1c"
                              : "#92400e",
                      }}
                    >
                      {rfq.response_status || "PENDING"}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        ) : (
          <>
            <div style={{ marginBottom: 16 }}>
              <h4
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#0f172a",
                  marginBottom: 0,
                }}
              >
                Submit Response
              </h4>
            </div>

            <Row className="g-4">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="text-muted small">Price</Form.Label>
                  <Form.Control
                    value={form.price}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        price: e.target.value.replace(/[^\d.]/g, ""),
                      })
                    }
                    placeholder="Enter price"
                    className="rounded-3 py-2"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="text-muted small">
                    Production Time
                  </Form.Label>

                  <Row className="g-2">
                    <Col md={6}>
                      <Form.Control
                        value={form.production_time}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            production_time: e.target.value.replace(/\D/g, ""),
                          })
                        }
                        placeholder="e.g. 30"
                        className="rounded-3 py-2"
                      />
                    </Col>

                    <Col md={6}>
                      <Form.Select
                        value={form.time_unit}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            time_unit: e.target.value,
                          })
                        }
                        className="rounded-3 py-2"
                      >
                        <option value="days">Days</option>
                        <option value="weeks">Weeks</option>
                        <option value="months">Months</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group>
                  <Form.Label className="text-muted small">Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={form.message}
                    onChange={(e) =>
                      setForm({ ...form, message: e.target.value })
                    }
                    placeholder="Write your proposal details"
                    className="rounded-3"
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="mt-4 d-flex gap-2">
              <Button
                style={{
                  backgroundColor: "#16a34a",
                  border: "none",
                  color: "#fff",
                  fontWeight: 600,
                  padding: "8px 16px",
                  borderRadius: 10,
                }}
                onClick={submitResponse}
              >
                Submit Response
              </Button>
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
